import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplateId} from '../../domain/workout-template-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type DeleteWorkoutTemplateInput = {
  readonly templateId: WorkoutTemplateId;
};

export class DeleteWorkoutTemplate
  implements UseCase<[DeleteWorkoutTemplateInput], void>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: DeleteWorkoutTemplateInput): Promise<Result<void, WorkoutError>> {
    return this.repository.deleteTemplate(input.templateId);
  }
}
